// BillingTab · thin orchestrator. Real logic lives in useBillingCheckout;
// per-plan UI lives in PlanCard.
import React from "react";
import { Card } from "./ui/card";
import { CreditCard, Loader2 } from "lucide-react";
import PlanCard from "./billing/PlanCard";
import { useBillingCheckout } from "../hooks/useBillingCheckout";

const PLAN_ORDER = ["starter", "professional", "enterprise"];

export default function BillingTab({ currentUser, onPlanChanged }) {
  const { packages, busy, polling, startCheckout } = useBillingCheckout({ onPlanChanged });

  const byPlan = packages.reduce((acc, p) => {
    (acc[p.plan] = acc[p.plan] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      <Card className="card-elevated p-6">
        <div className="flex items-center gap-3">
          <CreditCard className="w-5 h-5 text-accent" />
          <div>
            <div className="overline">Current plan</div>
            <h3 className="font-sans-ui font-semibold text-lg mt-1 capitalize" data-testid="current-plan">
              {currentUser?.plan || "starter"} {currentUser?.plan_billing ? `· ${currentUser.plan_billing}` : ""}
            </h3>
          </div>
        </div>
        {polling && (
          <div className="mt-4 text-sm text-muted-foreground flex items-center gap-2">
            <Loader2 className="w-4 h-4 animate-spin" /> Confirming payment with PayPal…
          </div>
        )}
      </Card>

      <div className="grid md:grid-cols-3 gap-5">
        {PLAN_ORDER.map((plan) => {
          const variants = byPlan[plan] || [];
          return (
            <PlanCard
              key={plan}
              plan={plan}
              monthly={variants.find((v) => v.billing === "monthly")}
              lifetime={variants.find((v) => v.billing === "lifetime")}
              isCurrent={(currentUser?.plan || "starter") === plan}
              busy={busy}
              onCheckout={startCheckout}
            />
          );
        })}
      </div>

      <p className="text-xs text-muted-foreground">
        Payments are processed by PayPal (sandbox mode). Use any PayPal sandbox buyer account to test.
      </p>
    </div>
  );
}
